import React from 'react';
import Settings from './Settings';
import Drop from './Drop';
import EditPaper from './EditPaper';
import Stores from './Stores';
import ListDone from './ListDone';
// import storesIconSrc from '@chama/statics/assets/svg/menu-item-shops.svg';
// import shopInfoIconSrc from '@chama/statics/assets/svg/menu-item-cadastro.svg';
// import orderHistoryIconSrc from '@chama/statics/assets/svg/menu-item-history.svg';

export const TYPES = {
  EDITABLE_INFO: 'EDITABLE_INFO',
  SHOP_INFO: 'SHOP_INFO',
  ORDER_HISTORY: 'ORDER_HISTORY',
  ORDERS: 'ORDERS',
  DEALERS: 'DEALERS',
};

const MenuItemIcon = ({ type }) => {
  switch (type) {
    case TYPES.ORDERS:
      return <Drop />;
    case TYPES.ORDER_HISTORY:
      return <ListDone />;
    case TYPES.SHOP_INFO:
      return <EditPaper />;
    case TYPES.DEALERS:
      return <Stores />;
    case TYPES.EDITABLE_INFO:
    default:
      return <Settings />;
  }
};

export default MenuItemIcon;



// WEBPACK FOOTER //
// ../ui-components/components/MenuItemIcon/index.jsx